import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

/**
 * Clears the Company-level supplier letter. The blob is retained in Filehub.
 *
 * @param companyId - The ID of the company.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Supplier-Letter/operation/delete_company_supplier_letter_vadmin_companies__company_id__supplier_letter_delete
 */
// fallow-ignore-next-line complexity
export const deleteCompanySupplierLetter = async (companyId: UUID) => {
  try {
    // 204 No Content per the OpenAPI spec — no response body to validate.
    await vestigasApi.delete(
      ENDPOINT.COMPANY.SUPPLIER_LETTER.DELETE(companyId),
    );
  } catch (error) {
    log.error({
      message: 'Error deleting company supplier letter',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.company.deleteCompanySupplierLetter.error422,
            { ns: 'data' },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.company.deleteCompanySupplierLetter.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    throw error;
  }
};
